export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ03.1046f50b.mp3";